import { Autocomplete } from "@material-ui/lab";
import { TextField, Checkbox } from "@material-ui/core";
import { useMemo } from "react";

export default function FilterAuto({
  label,
  name,
  options,
  value,
  onChange,
  multiple = false,
  width = 300,
}) {
  /* Map scalar value(s) → option object(s) whenever options or value changes */
  const selected = useMemo(() => {
    if (!options.length) return multiple ? [] : null;
    const byId = new Map(options.map((o) => [String(o.value), o]));

    return multiple
      ? (value ?? []).map((v) => byId.get(String(v))).filter(Boolean)
      : byId.get(String(value)) ?? null;
  }, [options, value, multiple]);

  const handle = (_, pick) => {
    const out = multiple ? pick.map((o) => o.value) : pick?.value ?? "";
    onChange(name, out);
  };

  return (
    <Autocomplete
      options={options}
      multiple={multiple}
      disableCloseOnSelect={multiple}
      loading={!options.length}
      value={selected}
      onChange={handle}
      getOptionLabel={(o) => o.label}
      getOptionSelected={(a, b) => a.value === b.value}
      style={{ minWidth: width, flexGrow: 1 }}
      renderOption={(o, { selected }) =>
        multiple ? (
          <>
            <Checkbox checked={selected} />
            {o.label}
          </>
        ) : (
          o.label
        )
      }
      renderInput={(p) => <TextField {...p} label={label} variant="outlined" />}
    />
  );
}
